module.exports = __webpack_public_path__ + "static/media/banner1.ae3756e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/msmarking/images/banner1.jpg
// module id = 528
// module chunks = 0